
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetotirupaticabsservice() {



    const cardData =
    {
        keyword: 'Pune to Tirupati Cabs Service ',
        heading: 'Platinum24 Cabs: Pune to Tirupati Cabs Service',
        headingDescription: ' Platinum24 Cabs offers dependable Pune to Tirupati cabs service, perfect for pilgrims, families, and long-distance travelers seeking a smooth journey to the holy Tirumala temple. Whether you’re planning a darshan at Lord Venkateswara Temple, a family trip, or a group pilgrimage, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures comfort and safety throughout the ride. With professional chauffeurs, timely pickups, and transparent pricing, we make your spiritual journey stress-free and convenient. From one-way rides to complete return packages, Platinum24 Cabs guarantees a reliable and comfortable Pune to Tirupati travel experience.',

        top: 'Top Places to Visit in Tirupati with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Sri Venkateswara Temple, Tirumala",
    "description": "The Sri Venkateswara Temple at Tirumala is one of the richest and most visited temples in the world. Dedicated to Lord Balaji (an incarnation of Lord Vishnu), it attracts millions of devotees annually. The temple’s Dravidian architecture and golden gopuram are breathtaking. Pilgrims wait for hours for darshan, believing it brings prosperity and salvation. Festivals like Brahmotsavam are celebrated with grandeur. It is Tirupati’s divine heart and India’s spiritual beacon."
  },
  {
    "title": "Sri Padmavathi Ammavari Temple",
    "description": "Located in Tiruchanur near Tirupati, this temple is dedicated to Goddess Padmavathi, consort of Lord Venkateswara. Devotees visit here before or after darshan at Tirumala for blessings. The temple’s architecture and spiritual ambiance are captivating. Special rituals and poojas attract thousands. Festivals like Kartheeka Brahmotsavam are celebrated vibrantly. Padmavathi Temple is Tirupati’s revered spiritual abode."
  },
  {
    "title": "Sri Govindaraja Swamy Temple",
    "description": "Sri Govindaraja Swamy Temple, built in 1130 AD by Saint Ramanuja, is one of Tirupati’s most historic temples. Dedicated to Lord Govindaraja, it is known for its massive gopuram and intricately carved halls. The temple complex also houses shrines of Sri Parthasarathi and Andal. Devotees believe it blesses them with wealth and prosperity. Its spiritual and architectural splendor makes it a must-visit. Govindaraja Swamy Temple is Tirupati’s historic sacred gem."
  },
  {
    "title": "Kapila Theertham",
    "description": "Kapila Theertham is a sacred Shiva temple located at the base of Tirumala hills. It is believed that Sage Kapila performed penance here, and the waterfall nearby is considered holy. Devotees take a dip in its waters during Kartika Masam for spiritual cleansing. The temple’s Dravidian architecture and serene setting attract pilgrims. Monsoon enhances its beauty with flowing cascades. Kapila Theertham is Tirupati’s divine natural retreat."
  },
  {
    "title": "Sri Venkateswara National Park",
    "description": "Spread across 350 sq km, Sri Venkateswara National Park is a biodiversity hotspot in the Eastern Ghats. It is home to tigers, leopards, deer, and over 1,500 plant species. Waterfalls like Talakona and Gundalakona add charm. Trekkers and nature lovers enjoy its scenic trails. The park is also spiritually significant due to its proximity to Tirumala. It is Tirupati’s perfect mix of nature and divinity."
  },
  {
    "title": "Talakona Waterfalls",
    "description": "Talakona Waterfalls, located inside Sri Venkateswara National Park, is the tallest waterfall in Andhra Pradesh at 270 feet. Surrounded by lush forests, it is ideal for trekking and picnics. The water here is believed to have medicinal properties. During monsoon, the falls are at their most spectacular. Nearby temples add a spiritual touch. Talakona is Tirupati’s refreshing natural wonder."
  },
  {
    "title": "Silathoranam",
    "description": "Silathoranam is a natural rock arch formation near Tirumala, one of only three such formations in the world. It is geologically significant and spiritually associated with Lord Venkateswara. The site offers stunning views, especially during sunrise and sunset. Surrounded by gardens, it is peaceful for visitors. Photographers and pilgrims alike love its uniqueness. Silathoranam is Tirupati’s rare natural marvel."
  },
  {
    "title": "Chandragiri Fort",
    "description": "Chandragiri Fort, built in the 11th century, is a historic site near Tirupati. Once the capital of the Vijayanagara Empire, it houses palaces, temples, and museums. The Raja Mahal now serves as an archaeological museum showcasing artifacts. The fort’s elevated location offers panoramic views. Light-and-sound shows narrate its royal history. Chandragiri Fort is Tirupati’s regal heritage monument."
  },
  {
    "title": "Sri Vari Museum",
    "description": "Sri Vari Museum, located near Tirumala Temple, preserves artifacts, sculptures, and religious collections related to Lord Venkateswara. Pilgrims learn about the temple’s history and rituals here. The museum showcases scriptures, weapons, and temple ornaments. Educational exhibits enrich the experience. It helps connect visitors to Tirumala’s cultural heritage. Sri Vari Museum is Tirupati’s spiritual knowledge hub."
  },
  {
    "title": "Regional Science Centre, Tirupati",
    "description": "The Regional Science Centre is an interactive museum for science enthusiasts and children. It features galleries on space, robotics, and natural sciences. 3D shows and planetarium sessions attract families. Its exhibits make learning entertaining and educational. Located amidst greenery, it also offers picnic spaces. The Science Centre is Tirupati’s modern educational attraction."
  }
],


                   "services": [
    {
      "name": "Pune to Tirupati Cab",
      "description": "Travel comfortably and safely with our Pune to Tirupati Cab service, offering well-maintained vehicles and professional drivers for your pilgrimage or leisure trips."
    },
    {
      "name": "Book Pune to Tirupati Taxi",
      "description": "Easily book your Pune to Tirupati Taxi online with instant confirmation, flexible timing, and competitive pricing for hassle-free travel."
    },
    {
      "name": "Pune to Tirupati Temple Cab",
      "description": "Specialized Pune to Tirupati Temple Cab service designed for pilgrims visiting the holy Tirupati temple, ensuring a comfortable and timely journey."
    },
    {
      "name": "Pune to Tirupati One Way Cab",
      "description": "Opt for our Pune to Tirupati One Way Cab for economical single-direction travel, perfect for one-way pilgrimages and business trips."
    },
    {
      "name": "Affordable Cabs Pune to Tirupati",
      "description": "Affordable Pune to Tirupati Cabs combining comfort and budget-friendly rates for travelers seeking value without compromising quality."
    },
    {
      "name": "Pune to Tirupati Outstation Taxi",
      "description": "Our Pune to Tirupati Outstation Taxi service offers reliable, safe, and comfortable intercity travel with experienced drivers and spacious vehicles."
    },
    {
      "name": "Pune to Tirupati Cab Booking",
      "description": "Book your Pune to Tirupati Cab conveniently with our online platform, featuring real-time availability, instant confirmation, and multiple payment options."
    },
    {
      "name": "Taxi Service from Pune to Tirupati",
      "description": "Dependable Taxi Service from Pune to Tirupati ensuring punctual pickups, professional drivers, and comfortable rides for all travelers."
    },
    {
      "name": "Tirupati to Pune Cab",
      "description": "Plan your return journey with our Tirupati to Pune Cab service, offering prompt service and well-maintained vehicles for a smooth ride back."
    },
    {
      "name": "Pune to Tirupati Car Hire",
      "description": "Flexible Pune to Tirupati Car Hire options including self-drive and chauffeur-driven cars to suit your travel preferences."
    },
    {
      "name": "Pune to Tirupati Taxi Charges",
      "description": "Transparent and affordable Pune to Tirupati Taxi Charges with no hidden fees, helping you plan your trip budget efficiently."
    }
  ],
  "tableData": [
    ["Pune to Tirupati Cab", "Book Pune to Tirupati Taxi"],
    ["Pune to Tirupati Temple Cab", "Pune to Tirupati One Way Cab"],
    ["Affordable Cabs Pune to Tirupati", "Pune to Tirupati Outstation Taxi"],
    ["Pune to Tirupati Cab Booking", "Taxi Service from Pune to Tirupati"],
    ["Tirupati to Pune Cab", "Pune to Tirupati Car Hire"],
    ["Pune to Tirupati Taxi Charges", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Pune to Tirupati Cabs Service",
    "WhyChoosedescription": "Platinum24 Cabs offers reliable and comfortable cab services from Pune to Tirupati, ensuring a smooth and pleasant journey."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Your Travel Needs",
    "WhyChoosedescription": "Choose from sedans, SUVs, hatchbacks, and tempo travellers that best fit your group size and preferences for Pune to Tirupati trips."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Safe Travel",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to provide a safe and hygienic environment during your Pune to Tirupati journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Tirupati Routes",
    "WhyChoosedescription": "Our skilled drivers know the best routes to ensure timely and hassle-free travel from Pune to Tirupati."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy transparent fares that include tolls, fuel, and driver allowances for your Pune to Tirupati cab service."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist you with bookings and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Your Convenience",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rental plans tailored to your Pune to Tirupati travel needs."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Pune to Tirupati cab quickly and securely through our website or app with immediate confirmation."
  }
]






















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide Pune to Tirupati cab service?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services from Pune to Tirupati with professional drivers and well-maintained vehicles.',
    },
    {
        question: 'How can I book a cab from Pune to Tirupati?',
        answer: 'You can book your cab through our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What vehicle options are available for Pune to Tirupati travel?',
        answer: 'We provide hatchbacks, sedans, SUVs, and luxury cars to suit your travel needs and preferences.',
    },
    {
        question: 'Is one-way cab service available from Pune to Tirupati?',
        answer: 'Yes, both one-way and round-trip cab services are available for Pune to Tirupati routes.',
    },
    {
        question: 'Are the drivers experienced for Pune to Tirupati long-distance trips?',
        answer: 'Absolutely, our drivers are licensed, professional, and familiar with the Pune to Tirupati route.',
    },
    {
        question: 'Can I customize my pickup and drop-off locations in Pune and Tirupati?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points within Pune and Tirupati.',
    },
    {
        question: 'What safety and hygiene protocols are followed for Pune to Tirupati cabs?',
        answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene measures to ensure passenger safety.',
    },
    {
        question: 'Is Pune to Tirupati cab service available 24x7?',
        answer: 'Yes, Platinum24 Cabs operates 24x7 for Pune to Tirupati cab bookings.',
    },
    {
        question: 'What payment options are accepted for Pune to Tirupati cab bookings?',
        answer: 'We accept cash, digital wallets, UPI, and major credit/debit cards for hassle-free payments.',
    },
    {
        question: 'Are there customizable packages for Pune to Tirupati cab service?',
        answer: 'Yes, we offer flexible and customizable packages tailored to your travel itinerary and preferences.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Anil Rao',
        feedback: 'My Pune to Tirupati journey was comfortable and smooth with Platinum24 Cabs. Highly recommended!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Kavya Sharma',
        feedback: 'Excellent service and professional drivers made my trip from Pune to Tirupati hassle-free and enjoyable.',
        rating: 5,
    },
];












































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];










const puneToTirupatiCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Tirupati Cab Service",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-tirupati-cab.jpg",
  "description": "Book Pune to Tirupati cab service with Platinum24 Cabs. Perfect for temple visits and outstation travel, choose from affordable sedans, SUVs, and reliable taxis. Available 24/7 with easy booking.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-tirupati-cab-service"
  }
};




    return (
        <div>

<Helmet>
  <title>Pune to Tirupati Cab Service | Affordable Temple & Outstation Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Tirupati cab service with Platinum24 Cabs. Perfect for temple visits and outstation travel, choose from affordable sedans, SUVs, and reliable taxis. Available 24/7 with easy booking."
  />
  <meta
    name="keywords"
    content="Pune to Tirupati Cab, Book Pune to Tirupati Taxi, Pune to Tirupati Temple Cab, Pune to Tirupati One Way Cab, Affordable Cabs Pune to Tirupati, Pune to Tirupati Outstation Taxi, Pune to Tirupati Cab Booking, Taxi Service from Pune to Tirupati, Tirupati to Pune Cab, Pune to Tirupati Car Hire, Pune to Tirupati Taxi Charges"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToTirupatiCabSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/106.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetotirupaticabsservice;